module.exports = __webpack_public_path__ + "DINNextRoundedLTPro-Medium.eot?611311c976af5bc238054a95600c4b6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextRoundedLTPro-Medium.eot
// module id = 312
// module chunks = 0